import { connect } from 'react-redux';
import * as actions from './ProjectedBalanceSheetActions';
import ProjectedBalanceSheetView from './ProjectedBalanceSheetView';
import { selectPortalName } from '../CommonSelectors/CommonAreaSelector';

const mapStateToProps = (state, ownProps) => {
  let subdivision = state.ProjectedBalanceSheet[ownProps.clientId];

  return {
    clientId: ownProps.clientId,
    error_type: subdivision ? subdivision.error_type : null,
    is_initialized: subdivision ? subdivision.is_initialized : false,
    ProjectedItems: subdivision ? subdivision.ProjectedItems : null,
    Periods: subdivision ? subdivision.Periods : null,
    errors: subdivision ? subdivision.errors : null,
    is_current: subdivision ? subdivision.is_current : ownProps.is_current,
    year: subdivision
      ? subdivision.year
      : `'${moment().format('YY')}-'${moment()
          .add(1, 'years')
          .format('YY')}`,
    PrincipalAgeOptions: subdivision ? subdivision.PrincipalAgeOptions : [],
    SpouseAgeOptions: subdivision ? subdivision.SpouseAgeOptions : [],
    PrincipalName: subdivision ? subdivision.PrincipalName : [],
    SpouseName: subdivision ? subdivision.SpouseName : [],
    Milestones: subdivision ? subdivision.Milestones : [],
    fpId: ownProps.fpId,
    portalName: selectPortalName(state),
    title: ownProps.title,
  };
};

const mapDispatchToProps = dispatch => ({
  fetch_data(is_current, owners, clientId, fpId, is_pdf, expandCurrentYear) {
    dispatch(actions.fetch_data(is_current, owners, clientId, fpId, is_pdf, expandCurrentYear));
  },
  set_current(is_current, clientId) {
    dispatch(actions.set_current(is_current, clientId));
  },
  set_projected(projected, clientId) {
    dispatch(actions.set_projected(projected, clientId));
  },
  set_year(year, clientId) {
    dispatch(actions.set_year(year, clientId));
  },
  unset_errors(clientId) {
    function return_function1() {
      dispatch(actions.set_errors('', this.clientId));
    }

    return return_function1.bind({ clientId });
  },
});

const ProjectedBalanceSheet = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProjectedBalanceSheetView);

export default ProjectedBalanceSheet;
